import {createRouter, createWebHistory} from 'vue-router'

const ProfileLayout = () => import('@/apps/profile/views/ProfileLayout.vue')
const Profile = () => import('@/apps/profile/views/pages/Profile.vue');
const Orders = () => import('@/apps/profile/views/pages/Orders.vue');
const ShopCart = () => import('@/apps/profile/views/pages/ShopCart.vue');
const PaymentForm = () => import('@/apps/profile/views/pages/PaymentForm.vue');
const AccountForm = () => import('@/apps/profile/views/pages/AccountForm.vue');

export default createRouter({
    history: createWebHistory(),
    linkActiveClass: 'active',
    scrollBehavior: () => ({left: 0, top: 0}),
    routes: [{
        path: window.appConfig.uriPrefix === 'profile' ? '/profile' : '/users/:userId/profile',
        redirect: {name: 'ProfileMy'},
        name: 'Profile',
        component: ProfileLayout,
        children: [
            {path: 'vetis/workspace', name: 'VetisWorkspace', component: () => import('@/apps/profile/views/pages/vetis/VetisApplications.vue'), props: {workspace: true}},
            {path: 'vetis/dispatch', name: 'VetisDispatch', component: () => import('@/apps/profile/views/pages/vetis/VetisDispatch.vue')},
            {path: 'vetis/new', name: 'VetisApplicationNew', component: () => import('@/apps/profile/views/pages/vetis/VetisApplicationForm.vue')},
            {path: 'vetis/:applicationId/edit', name: 'VetisApplicationEdit', component: () => import('@/apps/profile/views/pages/vetis/VetisApplicationForm.vue'), props: true},
            {path: 'vetis/:applicationId', name: 'VetisApplication', component: () => import('@/apps/profile/views/pages/vetis/VetisApplication.vue'), props: true},
            {path: 'vetis', name: 'VetisApplications', component: () => import('@/apps/profile/views/pages/vetis/VetisApplications.vue')},
            {path: 'notifications/settings', name: 'NotificationSettings', component: () => import('@/apps/profile/views/pages/NotificationSettings.vue')},
            {path: 'notifications', name: 'Notifications', component: () => import('@/apps/profile/views/pages/Notifications.vue')},
            {
                path: 'my',
                name: 'ProfileMy',
                component: Profile
            },
            {
                path: 'orders/:orderId?',
                name: 'Orders',
                component: Orders
            },
            {
                path: 'shop-cart',
                name: 'ShopCart',
                component: ShopCart,
            },
            {
                path: 'payment',
                name: 'PaymentForm',
                component: PaymentForm
            },
            {
                path: 'account/create',
                name: 'AccountForm',
                component: AccountForm
            },
        ]
    }]
});
